import axios from "@/axios";
import * as types from '../mutation-types';

export default {
    namespaced: true,
    state: {
        detailsTypes: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/Settings/DetailsType').then(({ data }) => {
                commit(types.STORE_DETAILS_TYPES, data)
                return data
            })
        },

        create({ commit }, { name, detailTypesOptions, detailTypes, Xprotected, withNotes }) {
            return axios.post('/Settings/DetailType', {  
                name, detailTypesOptions, detailTypes, protected: Xprotected, withNotes 
            })
        },

        update({ commit }, { id, name, detailTypesOptions, detailTypes, Xprotected, withNotes }) {
            return axios.put(`/Settings/DetailType/${id}`, {  
                name, detailTypesOptions, detailTypes, protected: Xprotected, withNotes 
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`/Settings/DetailType/${id}`)
        }
    },

    mutations: {
        [types.STORE_DETAILS_TYPES] (state, detailsTypes) {
            state.detailsTypes = detailsTypes
        }
    },

    getters: {
        getById: state => id => state.detailsTypes.find(c => c.id === id)
    }
}